export function* createSliceIterator<T>(limit: number, set: T[]) {
  let i = 0
  while (i < set.length) {
    yield set.slice(i, i + limit)
    i += limit
  }
}
